<template>
  <SfTabs :open-tab="1">
    <SfTab title="Товары">
      <p class="message">
        Здесь находятся избранные товары.
      </p>
      <transition name="fade" mode="out-in">
        <div v-if="totalItems" class="my-wishlist" key="my-wishlist">
          <div class="my-wishlist__total-items">Всего: <strong>{{ totalItems }}</strong></div>
          <div class="collected-product-list">
            <transition-group name="fade" tag="div">
              <SfCollectedProduct
                data-cy="collected-product-wishlist-sidebar"
                v-for="product in products"
                :key="product.slug"
                :image="getImage(product.image)"
                :title="product.name"
                :regular-price="productPrice(product)"
                :stock="99999"
                :link="{ name: 'product', params: { slug: product.slug } }"
                image-width="180"
                image-height="200"
                @click:remove="removeFromWishlist(product.id)"
                class="collected-product"
              >
                <template #input>
                  {{ '' }}
                </template>
                <template #actions>
                  {{ '' }}
                </template>
                <template #configuration>
                  {{ '' }}
                </template>
                <template #remove="{ removeHandler }">
                  <button @click="removeHandler" link="" class="sf-button sf-circle-icon sf-circle-icon--small sf-collected-product__remove sf-collected-product__remove--circle-icon" aria-label="Remove" style="outline: none;"><div class="sf-circle-icon__icon sf-icon" aria-hidden="true"><svg viewBox="0 0 24 24" preserveAspectRatio="none" class="sf-icon-path"><defs><!----></defs><path d="M21.261 2.22a.748.748 0 00-1.057 0l-8.464 8.463-8.463-8.464a.748.748 0 10-1.058 1.058l8.464 8.463-8.464 8.464a.748.748 0 101.058 1.057l8.463-8.463 8.464 8.463a.748.748 0 101.057-1.057l-8.463-8.464 8.463-8.463a.748.748 0 000-1.058z" fill="var(--icon-color)" style="height: 100%;"></path></svg><!----></div></button>
                  <button @click="removeHandler" link="" class="sf-button sf-button--text sf-collected-product__remove sf-collected-product__remove--text">Удалить</button>
                </template>
              </SfCollectedProduct>
            </transition-group>
          </div>
          <div class="sidebar-bottom">
          <SfProperty class="sf-property--full-width my-wishlist__total-price">
            <template #name>
              <span class="my-wishlist__total-price-label">Общая цена:</span>
            </template>
            <template #value>
              <SfPrice :regular="Intl.NumberFormat('uz-UZ', { minimumFractionDigits: 0 }).format(totalPrice) + ' сум'" />
            </template>
          </SfProperty>
          </div>
        </div>
        <div v-else class="empty-wishlist" key="empty-wishlist">
          <div class="empty-wishlist__banner">
            <img src="@storefront-ui/shared/icons/empty_cart.svg" alt class="empty-wishlist__icon" />
            <h3 class="empty-wishlist__label">Ваш список пуст</h3>
            <p class="empty-wishlist__description">
              Выглядит так, словно вы ещё не добавили товаров список.
            </p>
          </div>
          <router-link :to="{ name: 'catalog' }">
            <SfButton class="sf-button--full-width color-secondary">Начать шоппинг</SfButton>
          </router-link>
        </div>
      </transition>
    </SfTab>
    <SfTab title="Магазины">
      <p class="message">
        Здесь находятся избранные магазины.
      </p>
      <transition name="fade" mode="out-in">
        <div v-if="totalShops" class="my-wishlist" key="my-wishlist">
          <div class="collected-product-list">
            <transition-group name="fade" tag="div">
              <SfCollectedProduct
                data-cy="collected-product-wishlist-sidebar"
                v-for="shop in shops"
                :key="shop.slug"
                :image="getImage(shop.logo)"
                :title="shop.name"
                :link="{ name: 'shop', params: { shop: shop.slug } }"
                image-width="180"
                image-height="200"
                @click:remove="removeShopFromWishlist(shop.id)"
                class="collected-product"
              >
                <template #input>
                  {{ '' }}
                </template>
                <template #actions>
                  {{ '' }}
                </template>
                <template #configuration>
                  {{ '' }}
                </template>
                <template #remove="{ removeHandler }">
                  <button @click="removeHandler" link="" class="sf-button sf-circle-icon sf-circle-icon--small sf-collected-product__remove sf-collected-product__remove--circle-icon" aria-label="Remove" style="outline: none;"><div class="sf-circle-icon__icon sf-icon" aria-hidden="true"><svg viewBox="0 0 24 24" preserveAspectRatio="none" class="sf-icon-path"><defs><!----></defs><path d="M21.261 2.22a.748.748 0 00-1.057 0l-8.464 8.463-8.463-8.464a.748.748 0 10-1.058 1.058l8.464 8.463-8.464 8.464a.748.748 0 101.058 1.057l8.463-8.463 8.464 8.463a.748.748 0 101.057-1.057l-8.463-8.464 8.463-8.463a.748.748 0 000-1.058z" fill="var(--icon-color)" style="height: 100%;"></path></svg><!----></div></button>
                  <button @click="removeHandler" link="" class="sf-button sf-button--text sf-collected-product__remove sf-collected-product__remove--text">Удалить</button>
                </template>
              </SfCollectedProduct>
            </transition-group>
          </div>
        </div>
        <div v-else class="empty-wishlist" key="empty-wishlist">
          <div class="empty-wishlist__banner">
            <img src="@storefront-ui/shared/icons/empty_cart.svg" alt class="empty-wishlist__icon" />
            <h3 class="empty-wishlist__label">Ваш список пуст</h3>
            <p class="empty-wishlist__description">
              Выглядит так, словно вы ещё не добавили магазин в список.
            </p>
          </div>
          <router-link :to="{ name: 'shops' }">
            <SfButton class="sf-button--full-width color-secondary">Начать шоппинг</SfButton>
          </router-link>
          
        </div>
      </transition>
    </SfTab>
    <SfTab title="Ювелирные изделия">
      <p class="message">
        Здесь находятся избранные ювелирные изделия.
      </p>
      <transition name="fade" mode="out-in">
        <div v-if="totalManufactors" class="my-wishlist" key="my-wishlist">
          <div class="collected-product-list">
            <transition-group name="fade" tag="div">
              <SfCollectedProduct
                data-cy="collected-product-wishlist-sidebar"
                v-for="manufactor in manufactors"
                :key="manufactor.id"
                :image="getImage(manufactor.image)"
                :title="manufactor.name"
                :link="{ name: 'manufacturer', params: { id: manufactor.id } }"
                image-width="180"
                image-height="200"
                @click:remove="removeManufactorFromWishlist(manufactor.id)"
                class="collected-product"
              >
                <template #input>
                  {{ '' }}
                </template>
                <template #actions>
                  {{ '' }}
                </template>
                <template #configuration>
                  {{ '' }}
                </template>
                <template #remove="{ removeHandler }">
                  <button @click="removeHandler" link="" class="sf-button sf-circle-icon sf-circle-icon--small sf-collected-product__remove sf-collected-product__remove--circle-icon" aria-label="Remove" style="outline: none;"><div class="sf-circle-icon__icon sf-icon" aria-hidden="true"><svg viewBox="0 0 24 24" preserveAspectRatio="none" class="sf-icon-path"><defs><!----></defs><path d="M21.261 2.22a.748.748 0 00-1.057 0l-8.464 8.463-8.463-8.464a.748.748 0 10-1.058 1.058l8.464 8.463-8.464 8.464a.748.748 0 101.058 1.057l8.463-8.463 8.464 8.463a.748.748 0 101.057-1.057l-8.463-8.464 8.463-8.463a.748.748 0 000-1.058z" fill="var(--icon-color)" style="height: 100%;"></path></svg><!----></div></button>
                  <button @click="removeHandler" link="" class="sf-button sf-button--text sf-collected-product__remove sf-collected-product__remove--text">Удалить</button>
                </template>
              </SfCollectedProduct>
            </transition-group>
          </div>
        </div>
        <div v-else class="empty-wishlist" key="empty-wishlist">
          <div class="empty-wishlist__banner">
            <img src="@storefront-ui/shared/icons/empty_cart.svg" alt class="empty-wishlist__icon" />
            <h3 class="empty-wishlist__label">Ваш список пуст</h3>
            <p class="empty-wishlist__description">
              Выглядит так, словно вы ещё не добавили магазин в список.
            </p>
          </div>
          <router-link :to="{ name: 'shops' }">
            <SfButton class="sf-button--full-width color-secondary">Начать шоппинг</SfButton>
          </router-link>
          
        </div>
      </transition>
    </SfTab>
    <SfTab title="Ювелиры">
      <p class="message">
        Здесь находятся избранные ювелиры.
      </p>
      <transition name="fade" mode="out-in">
        <div v-if="totalManufactorShops" class="my-wishlist" key="my-wishlist">
          <div class="collected-product-list">
            <transition-group name="fade" tag="div">
              <SfCollectedProduct
                data-cy="collected-product-wishlist-sidebar"
                v-for="shop in manufactorShops"
                :key="shop.slug"
                :image="getImage(shop.logo)"
                :title="shop.name"
                :link="{ name: 'manufacturer-shop', params: { shop: shop.slug } }"
                image-width="180"
                image-height="200"
                @click:remove="removeManufactorShopFromWishlist(shop.id)"
                class="collected-product"
              >
                <template #input>
                  {{ '' }}
                </template>
                <template #actions>
                  {{ '' }}
                </template>
                <template #configuration>
                  {{ '' }}
                </template>
                <template #remove="{ removeHandler }">
                  <button @click="removeHandler" link="" class="sf-button sf-circle-icon sf-circle-icon--small sf-collected-product__remove sf-collected-product__remove--circle-icon" aria-label="Remove" style="outline: none;"><div class="sf-circle-icon__icon sf-icon" aria-hidden="true"><svg viewBox="0 0 24 24" preserveAspectRatio="none" class="sf-icon-path"><defs><!----></defs><path d="M21.261 2.22a.748.748 0 00-1.057 0l-8.464 8.463-8.463-8.464a.748.748 0 10-1.058 1.058l8.464 8.463-8.464 8.464a.748.748 0 101.058 1.057l8.463-8.463 8.464 8.463a.748.748 0 101.057-1.057l-8.463-8.464 8.463-8.463a.748.748 0 000-1.058z" fill="var(--icon-color)" style="height: 100%;"></path></svg><!----></div></button>
                  <button @click="removeHandler" link="" class="sf-button sf-button--text sf-collected-product__remove sf-collected-product__remove--text">Удалить</button>
                </template>
              </SfCollectedProduct>
            </transition-group>
          </div>
        </div>
        <div v-else class="empty-wishlist" key="empty-wishlist">
          <div class="empty-wishlist__banner">
            <img src="@storefront-ui/shared/icons/empty_cart.svg" alt class="empty-wishlist__icon" />
            <h3 class="empty-wishlist__label">Ваш список пуст</h3>
            <p class="empty-wishlist__description">
              Выглядит так, словно вы ещё не добавили магазин в список.
            </p>
          </div>
          <router-link :to="{ name: 'shops' }">
            <SfButton class="sf-button--full-width color-secondary">Начать шоппинг</SfButton>
          </router-link>
          
        </div>
      </transition>
    </SfTab>
    <SfTab title="Инструменты">
      <p class="message">
        Здесь находятся избранные инструменты.
      </p>
      <transition name="fade" mode="out-in">
        <div v-if="totalInstruments" class="my-wishlist" key="my-wishlist">
          <div class="collected-product-list">
            <transition-group name="fade" tag="div">
              <SfCollectedProduct
                data-cy="collected-product-wishlist-sidebar"
                v-for="manufactor in instruments"
                :key="manufactor.id"
                :image="getImage(manufactor.image)"
                :title="manufactor.name"
                :link="{ name: 'instrument', params: { id: manufactor.id } }"
                image-width="180"
                image-height="200"
                @click:remove="removeInstrumentFromWishlist(manufactor.id)"
                class="collected-product"
              >
                <template #input>
                  {{ '' }}
                </template>
                <template #actions>
                  {{ '' }}
                </template>
                <template #configuration>
                  {{ '' }}
                </template>
                <template #remove="{ removeHandler }">
                  <button @click="removeHandler" link="" class="sf-button sf-circle-icon sf-circle-icon--small sf-collected-product__remove sf-collected-product__remove--circle-icon" aria-label="Remove" style="outline: none;"><div class="sf-circle-icon__icon sf-icon" aria-hidden="true"><svg viewBox="0 0 24 24" preserveAspectRatio="none" class="sf-icon-path"><defs><!----></defs><path d="M21.261 2.22a.748.748 0 00-1.057 0l-8.464 8.463-8.463-8.464a.748.748 0 10-1.058 1.058l8.464 8.463-8.464 8.464a.748.748 0 101.058 1.057l8.463-8.463 8.464 8.463a.748.748 0 101.057-1.057l-8.463-8.464 8.463-8.463a.748.748 0 000-1.058z" fill="var(--icon-color)" style="height: 100%;"></path></svg><!----></div></button>
                  <button @click="removeHandler" link="" class="sf-button sf-button--text sf-collected-product__remove sf-collected-product__remove--text">Удалить</button>
                </template>
              </SfCollectedProduct>
            </transition-group>
          </div>
        </div>
        <div v-else class="empty-wishlist" key="empty-wishlist">
          <div class="empty-wishlist__banner">
            <img src="@storefront-ui/shared/icons/empty_cart.svg" alt class="empty-wishlist__icon" />
            <h3 class="empty-wishlist__label">Ваш список пуст</h3>
            <p class="empty-wishlist__description">
              Выглядит так, словно вы ещё не добавили магазин в список.
            </p>
          </div>
          <router-link :to="{ name: 'shops' }">
            <SfButton class="sf-button--full-width color-secondary">Начать шоппинг</SfButton>
          </router-link>
          
        </div>
      </transition>
    </SfTab>
    <SfTab title="Ювелиры">
      <p class="message">
        Здесь находятся избранные ювелиры.
      </p>
      <transition name="fade" mode="out-in">
        <div v-if="totalInstrumentShops" class="my-wishlist" key="my-wishlist">
          <div class="collected-product-list">
            <transition-group name="fade" tag="div">
              <SfCollectedProduct
                data-cy="collected-product-wishlist-sidebar"
                v-for="shop in instrumentShops"
                :key="shop.slug"
                :image="getImage(shop.logo)"
                :title="shop.name"
                :link="{ name: 'instrument-shop', params: { shop: shop.slug } }"
                image-width="180"
                image-height="200"
                @click:remove="removeInstrumentShopFromWishlist(shop.id)"
                class="collected-product"
              >
                <template #input>
                  {{ '' }}
                </template>
                <template #actions>
                  {{ '' }}
                </template>
                <template #configuration>
                  {{ '' }}
                </template>
                <template #remove="{ removeHandler }">
                  <button @click="removeHandler" link="" class="sf-button sf-circle-icon sf-circle-icon--small sf-collected-product__remove sf-collected-product__remove--circle-icon" aria-label="Remove" style="outline: none;"><div class="sf-circle-icon__icon sf-icon" aria-hidden="true"><svg viewBox="0 0 24 24" preserveAspectRatio="none" class="sf-icon-path"><defs><!----></defs><path d="M21.261 2.22a.748.748 0 00-1.057 0l-8.464 8.463-8.463-8.464a.748.748 0 10-1.058 1.058l8.464 8.463-8.464 8.464a.748.748 0 101.058 1.057l8.463-8.463 8.464 8.463a.748.748 0 101.057-1.057l-8.463-8.464 8.463-8.463a.748.748 0 000-1.058z" fill="var(--icon-color)" style="height: 100%;"></path></svg><!----></div></button>
                  <button @click="removeHandler" link="" class="sf-button sf-button--text sf-collected-product__remove sf-collected-product__remove--text">Удалить</button>
                </template>
              </SfCollectedProduct>
            </transition-group>
          </div>
        </div>
        <div v-else class="empty-wishlist" key="empty-wishlist">
          <div class="empty-wishlist__banner">
            <img src="@storefront-ui/shared/icons/empty_cart.svg" alt class="empty-wishlist__icon" />
            <h3 class="empty-wishlist__label">Ваш список пуст</h3>
            <p class="empty-wishlist__description">
              Выглядит так, словно вы ещё не добавили магазин в список.
            </p>
          </div>
          <router-link :to="{ name: 'shops' }">
            <SfButton class="sf-button--full-width color-secondary">Начать шоппинг</SfButton>
          </router-link>
          
        </div>
      </transition>
    </SfTab>
  </SfTabs>
</template>
<script>
import { SfTabs, SfButton, SfProperty, SfPrice, SfCollectedProduct } from "@storefront-ui/vue";

import { createNamespacedHelpers } from 'vuex'
const { mapState, mapMutations } = createNamespacedHelpers('wishlist');


export default {
  name: "PersonalDetails",
  components: {
    SfTabs,
    SfButton,
    SfProperty,
    SfPrice,
    SfCollectedProduct
  },
  props: {
    account: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      tableHeaders: [
        "Order ID",
        "Payment date",
        "Payment method",
        "Amount",
        "Status",
      ],
    };
  },
  computed: {
    ...mapState({
      products: 'products',
      shops: 'shops',
      manufactorShops: 'manufactorShops',
      manufactors: 'manufactors',
      instrumentShops: 'instrumentShops',
      instruments: 'instruments',
      isWishlistSidebarOpen: 'isOpen'
    }),
    orders() {
      return this.account.orders;
    },
    totalPrice() {
      const products = this.products
      let total = 0
      for(let product of products) {
        let price = 0;
        // Fonon
        if(product.shop.id === 22) {
          if(product.weight) {
            price = product.weight * 100000
          }
        }
        // jeWell
        else if(product.shop.id === 21) {
          price = 10581 * product.price
        } else {
          price = product.price
        }
        total += Number(price)
      }
      return total
    },
    totalItems() {
      return this.products.length
    },
    totalShops() {
      return this.shops.length
    },
    totalManufactors() {
      return this.manufactors.length
    },
    totalManufactorShops() {
      return this.manufactorShops.length
    },
    totalInstruments() {
      return this.instruments.length
    },
    totalInstrumentShops() {
      return this.instrumentShops.length
    }
  },

  methods: {
    ...mapMutations({
      readProducts: 'READ_PRODUCTS',
      toggleWishlistSidebar: 'TOGGLE_SIDEBAR',
      removeFromWishlist: 'REMOVE_PRODUCT',
      removeShopFromWishlist: 'REMOVE_SHOP',
      removeManufactorFromWishlist: 'REMOVE_MANUFACTOR',
      removeManufactorShopFromWishlist: 'REMOVE_MANUFACTOR_SHOP',
      removeInstrumentFromWishlist: 'REMOVE_INSTRUMENT',
      removeInstrumentShopFromWishlist: 'REMOVE_INSTRUMENT_SHOP',
    }),
    getImage(image) {
      const imageCont = image.split('.');
      return `${process.env.VUE_APP_STORAGE}/${imageCont[0]}-cropped.${imageCont[1]}`
    },
    productPrice(product) {
      let price = 0;
      // Fonon
      if(product.shop.id === 22) {
        if(product.price) {
          price = product.price
        } else if(product.weight && (product.specification_insert == 'empty' && product.specification_insert2 == 'empty')) {
          if(product.specification_probe == 583 || product.specification_probe == 585) {
            price = product.weight * product.shop.probe_583_price
          } else if(product.specification_probe == 750) {
            price = product.weight * product.shop.probe_750_price
          }
        }
      }
      // jeWell
      else if(product.shop.id === 21 || product.shop.id === 19) {
        price = 10581 * product.price
      } else {
        price = product.price
      }

      if(price) {
        return Intl.NumberFormat('uz-UZ', { minimumFractionDigits: 0 }).format(price) + ' сум'
      } else return ''
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@storefront-ui/vue/styles";
.no-orders {
  &__title {
    margin: 0 0 var(--spacer-base) 0;
  }
  &__button {
    --button-width: 100%;
    margin: var(--spacer-2xl) 0 0 0;
    @include for-desktop {
      --button-width: 17.375rem;
    }
  }
}
.orders {
  @include for-desktop {
    &__element {
      &--right {
        text-align: right;
      }
    }
  }
}
.message {
  margin: 0 0 var(--spacer-xl) 0;
  color: var(--c-dark-variant);
}
a {
  color: var(--c-primary);
  font-weight: var(--font-weight--medium);
  text-decoration: none;
  &:hover {
    color: var(--c-text);
  }
}

.collected-product {
  margin: var(--spacer-base) 0;
  &__properties {
    margin: var(--spacer-sm) 0 0 0;
  }
  ::v-deep .sf-collected-product__remove--circle-icon {
    --button-background: var(--c-primary);
    --icon-color: var(--c-white);
  }
}

.my-wishlist {
  flex: 1;
  display: flex;
  flex-direction: column;
  &__total-items {
    font: var(--font-weight--normal) var(--font-size--lg) / 1.6 var(--font-family--secondary);
    color: var(--c-link);
    margin: 0;
  }
  &__total-price {
    --property-name-font-size: var(--font-size--xl);
    --price-font-size: var(--font-size--xl);
    margin: 0 0 var(--spacer-xl) 0;
    &-label {
      font: var(--font-weight--normal) var(--font-size--2xl) / 1.6 var(--font-family--secondary);
      color: var(--c-link);
    }
  }
}
.empty-wishlist {
  display: flex;
  flex: 1;
  flex-direction: column;
  &__banner {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  &__label,
  &__description {
    text-align: center;
  }
  &__label {
    margin: var(--spacer-2xl) 0 0 0;
    font: var(--font-weight--normal) var(--font-size--xl) / 1.6 var(--font-family--secondary);
    color: var(--c-primary);
  }
  &__description {
    margin: var(--spacer-sm) 0 0 0;
    font: var(--font-weight--normal) var(--font-size--base) / 1.6 var(--font-family--primary);
    color: var(--c-link);
  }
  &__icon {
    width: 18.125rem;
    height: 12.3125rem;
    margin-left: 50%;
    @include for-desktop {
      margin-left: 45%;
    }
  }
}
</style>